<template>
  <div class="sidebar-layout">
    <div class="sidebar">
      <slot name="sidebar" />
    </div>
    <div class="context">
      <slot name="context" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBarLayout"
}
</script>

<style scoped>
.sidebar-layout {
  width: 100%;
  min-height: 100vh;
  display: flex;
}
.sidebar-layout .sidebar {
  flex-shrink: 0;
  width: 370px;
  height: calc(100vh - 64px);
  overflow-y: scroll;
  overflow-x: hidden;
  position: fixed;
}
.sidebar-layout .context {
  flex-grow: 1;
  margin-left: 370px;
  min-width: 0;
}
</style>